import { Box, SkeletonGroup, SkeletonLine } from '@wix/design-system';
import React from 'react';
export const SkeletonLoader = () => {
  return /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(SkeletonLine, null), /*#__PURE__*/React.createElement(SkeletonLine, {
    width: "65%"
  })));
};
//# sourceMappingURL=SkeletonLoader.js.map